import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { PortalService } from '../../services/portal/portal.service';

/**
 * Gates the /portal subtree: it exists only for accounts whose organization has at
 * least one portal relation (in ANY status - revoked/deactivated relations still
 * grant a read-only view of history, per the brief). Everyone else goes to the
 * producer app root, which applies its own subscription routing.
 */
export const portalGuard: CanMatchFn = () => {
  const portalService = inject(PortalService);
  const router = inject(Router);

  return portalService.getSuppliers().pipe(
    map((suppliers) => (suppliers.length > 0 ? true : router.createUrlTree(['/']))),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
